import React, { useState } from 'react';
import cn from 'classnames';
import { Link, NavLink, useHistory } from 'react-router-dom';

import { ReactComponent as Logo } from 'assets/images/logo.svg';
import { ReactComponent as Search } from 'assets/images/search.svg';
import { ReactComponent as Burger } from 'assets/images/burger.svg';
import ButtonLogout from 'components/ButtonLogout';
import VerticalDivider from 'components/VerticalDivider';
import Navigation from 'components/Navigation';
import SearchInput from 'components/SearchInput';
import Chats from 'components/Chats';
import { useAuth } from 'context/auth.context';
import { useUI } from 'context/ui.context';
import TariffInfo from 'components/TariffInfo';
import { PAGE_PROFILE_SUBSCRIPTIONS } from 'constants/pages';
// import { useMainLinkDefault } from 'hooks/useLocationPath';
// import AnalyticType from '../AnalyticType/AnalyticType';
import { useFilterReducer } from 'context/filter/filter.context.reducer';
import { useAnalyticType } from 'context/analytic.type.context';
import { InnerNotification } from '../Notification';

const Header = () => {
  const { logout, setUser, user, tariff } = useAuth();
  const { setActiveModal, activeModal, isDesktop } = useUI();
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  const { isInner, setOuterTypeChange } = useAnalyticType();
  const { changeFilterType } = useFilterReducer();
  // const mainLink = useMainLinkDefault();
  const history = useHistory();

  const handleLogout = async () => {
    logout().then(() => setUser(null));
  };

  const handleGoToMain = () => {
    setOuterTypeChange();

    if (isInner) {
      changeFilterType({ nextLink: '/navigation', prevLink: window.location.pathname });
    }

    history.push('/navigation');
  };
  const isSeo = window.location.pathname.startsWith('/seo');
  return (
    <>
      <header
        className={cn(
          'items-center lg:items-stretch flex justify-between shadow-sm h-16 px-6 relative header mb-0 z-[50]',
          {
            ['z-[10102]']: activeModal === 'search',
          },
        )}
      >
        <div className="mr-auto lg:mr-0 flex items-stretch flex-grow">
          <button className="flex items-center" onClick={handleGoToMain}>
            <Logo className="self-center" />
          </button>
          {isDesktop && (
            <>
              <NavLink to={'/navigation'} className="h-fit self-center ml-4 block">
                <button
                  className={
                    'block h-8 border-green border px-[11px] !py-[5px] text-green rounded hover:text-white hover:bg-green'
                  }
                >
                  Меню
                </button>
              </NavLink>
              {/*<AnalyticType />*/}
              {!isSearchExpanded && <Navigation />}
              {tariff && !isSeo && (
                <SearchInput isExpanded={isSearchExpanded} setIsExpanded={setIsSearchExpanded} />
              )}
              <TariffInfo />
              <div className="flex items-center">
                <VerticalDivider>
                  <div className="flex items-center relative top-0.5">
                    <Link to={PAGE_PROFILE_SUBSCRIPTIONS} className="text-green flex">
                      <span className="self-center block">{user && user.email}</span>
                    </Link>
                    <Chats />
                  </div>
                  {user && <ButtonLogout onClick={handleLogout} />}
                </VerticalDivider>
              </div>
            </>
          )}
        </div>
        {!isDesktop && (
          <>
            <Chats />
            <div
              onClick={() =>
                activeModal === 'search' ? setActiveModal('') : setActiveModal('search')
              }
              className="flex w-6 justify-center items-center"
            >
              <Search />
            </div>
            <div
              onClick={() => setActiveModal('menu')}
              className="flex h-5 w-8 justify-center border-l-2 items-center ml-3 pl-3"
            >
              <Burger />
            </div>
          </>
        )}
      </header>
      <InnerNotification />
    </>
  );
};

export default Header;
